/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of a Principal webservice DTO used for defining User data types
 * @export
 * @interface Principal
 */
export interface Principal {
    /**
     * Unique user identifier
     * @type {string}
     * @memberof Principal
     */
    uid?: string;
    /**
     * Name of the user
     * @type {string}
     * @memberof Principal
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Principal
     */
    orgUnitId?: string;
}

/**
 * Check if a given object implements the Principal interface.
 */
export function instanceOfPrincipal(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PrincipalFromJSON(json: any): Principal {
    return PrincipalFromJSONTyped(json, false);
}

export function PrincipalFromJSONTyped(json: any, ignoreDiscriminator: boolean): Principal {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uid': !exists(json, 'uid') ? undefined : json['uid'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'orgUnitId': !exists(json, 'orgUnitId') ? undefined : json['orgUnitId'],
    };
}

export function PrincipalToJSON(value?: Principal | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'uid': value.uid,
        'name': value.name,
        'orgUnitId': value.orgUnitId,
    };
}

